module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABCklEQVR4AWOgC3ghqEskwtAgoPuCT++lrPYbQ/XXRmov5bSAXKAgbg38um+sVb52iv7cxPNzC8/XHpE3diogDQLYNDzn1Xutr/59ruCvPVzfl/P/WMH/cxf390UCQKuAUhgaBEDGf4iX/X2M8+sk4XcBCu/8FL72C/8+yvkxTQasAFODsO7ncgmgqZ+KJL+0i37pFAUyfm7l+Vwn/kJE5wU/Nhs+Jsr+Ps7xzkfx5x6uX0c533oo/T7GAbQB7A1MTwP9YKD+fb7Ar0OcX3tFgD7+tZ/r+xL+1yZqQCksnoYY89ZW5Wu3CNBhP3dwf+0XeeugDBbHHw9yWm9M1V4bq71UQI8H0mN6UAIALYzG99mkRe0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/KG.png
// module id = 1179
// module chunks = 0